import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    permissions: [],
    loading: false,
    error: null,
};

export const getPermissionsListById = createAsyncThunk(
    "permissionsListById",
    async ({user, id}) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.backoffice;
            const endpointpath = endpoint?.backoffice?.permission;
            const institution = id || user?.institution?.value;

            const apiURL = base + endpointpath + institution;

            const response = await axiosInstance.get(apiURL);
            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const permissionsListSlice = createSlice({
    name: "permissions list",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPermissionsListById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getPermissionsListById.fulfilled, (state, action) => {
                state.loading = false;
                state.permissions = action?.payload || [];
            })
            .addCase(getPermissionsListById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default permissionsListSlice.reducer;